
import { defineComponent } from "vue";
import npxTable from "@/components/neopixel/npxTable.vue";

export default defineComponent({
  name: "statuses-list",
  components: {
    npxTable,
  },
});
